'use client';

import { useEffect, useRef, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Collapse, Box, Button, Typography } from '@mui/material';
import { Rotate } from '@qb/frontend/components/Rotate';
const COLLAPSE_MIN_HEIGHT = 88;
type PartDescriptionCollapseProps = {
  shortDescription: string;
  longDescription: string;
};
export const PartLongDescription = ({
  shortDescription,
  longDescription
}: PartDescriptionCollapseProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isEnoughTextToExpand, setIsEnoughTextToExpand] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const paragraphs = longDescription.split('\n').filter(Boolean);
  useEffect(() => {
    if (contentRef.current) {
      setIsEnoughTextToExpand(contentRef.current.scrollHeight > COLLAPSE_MIN_HEIGHT);
    }
  }, []);
  if (shortDescription.trim().toLowerCase() === longDescription.trim().toLowerCase()) {
    // hide about the product if it’s the same as “product description”
    return null;
  }
  return <Box sx={{
    minHeight: COLLAPSE_MIN_HEIGHT + 16,
    mt: 4
  }} data-sentry-element="Box" data-sentry-component="PartLongDescription" data-sentry-source-file="PartLongDescription.tsx">
      <Typography variant="h4" component="h3" sx={{
      mb: 2
    }} data-sentry-element="Typography" data-sentry-source-file="PartLongDescription.tsx">
        About the product
      </Typography>
      <Collapse in={isExpanded} collapsedSize={COLLAPSE_MIN_HEIGHT} sx={theme => ({
      my: 2,
      position: 'relative',
      '&::after': {
        display: isExpanded || !isEnoughTextToExpand ? 'none' : 'block',
        content: '"..."',
        typography: 'paragraph',
        background: `linear-gradient(to right, transparent 10%, ${theme.palette.common.white} 60%)`,
        position: 'absolute',
        bottom: 0,
        right: 0,
        pl: 3,
        pb: 0.5
      }
    })} data-sentry-element="Collapse" data-sentry-source-file="PartLongDescription.tsx">
        <Box ref={contentRef} data-sentry-element="Box" data-sentry-source-file="PartLongDescription.tsx">
          {paragraphs.map((paragraph, index) => <Typography key={index} variant="paragraph" align="justify">
              {paragraph}
            </Typography>)}
        </Box>
      </Collapse>
      {isEnoughTextToExpand && <Button onClick={() => setIsExpanded(prev => !prev)} variant="text" color="primary" sx={{
      display: 'flex',
      mx: 'auto'
    }} endIcon={<Rotate isRotated={isExpanded}>
              <ExpandMoreIcon />
            </Rotate>}>
          {`Read ${isExpanded ? 'less' : 'more'}`}
        </Button>}
    </Box>;
};